import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import styled from 'styled-components'

const DefaultLink = props => (
  <a href="#select" {...props}>
    {props.children}
  </a>
)

const DefaultWrapper = 'span'
const HiddenInput = styled.input`
  visibility: hidden;
  width: 0;
  height: 0;
  position: absolute;
  left: -9999px;
`

const makeFileInputLink = ({ Link = DefaultLink, Wrapper = DefaultWrapper } = {}) => {
  const FileInputLink = ({ children, onChange, ...props }) => {
    let inputRef

    const handleClick = e => {
      e.preventDefault()
      inputRef.click()
    }

    const onChange_ = useCallback(
      e => {
        e.preventDefault()

        onChange([...e.target.files])
        // Reset input so selecting the same file again triggers onChange
        e.target.value = ''
      },
      [onChange]
    )

    return (
      <Wrapper>
        <HiddenInput
          type="file"
          ref={ref => {
            inputRef = ref
          }}
          onChange={onChange_}
          {...props}
        />
        <Link onClick={handleClick}>{children}</Link>
      </Wrapper>
    )
  }

  FileInputLink.propTypes = {
    children: PropTypes.node,
    onChange: PropTypes.func.isRequired,
  }

  return FileInputLink
}

const FileInputLink = makeFileInputLink()

export default FileInputLink
export { makeFileInputLink, DefaultLink, DefaultWrapper }
